import './Organiser.css'
import closebutton from '../../assests/closebutton.svg'
import { useEffect } from 'react'

function Organiser({ organiserDetails, setShowDetails }) {
  useEffect(() => {
    window.scroll(0, 0)
  }, [setShowDetails])
  return (
    <div className='organiser pt-[50px] min-h-[100vh]'>
      {/* <div className='flex '> */}
      <button className='button flex items-center justify-center' onClick={() => setShowDetails(false)}>
        <img src={closebutton} alt="" className='w-[14px] h-[14px]' />
      </button>
      {/* </div> */}
      <p className='mt-[30px] organiser-name px-[30px]'>{organiserDetails.name}</p>
      <img src={organiserDetails?.coverImage} className="w-[100%] max-h-[400px] object-cover mt-[20px]" alt='' />
      <div className='organiser-description mt-[20px] pb-[106px] px-[30px] h-[100%]'>
        {organiserDetails?.about?.split("|").map((el) => {
          return (
            <p className='mt-[20px]'>{el}</p>
          )
        })}

      </div >
    </div>
  )
}

export default Organiser